import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_featured_fair_trade: FaireCategoryEntity = {
  token: "cat_featured-fair-trade",
  type: "category",
  name: "Fair Trade Federation",
  level: 2,
  parentToken: "cat_featured-brands",
  href: "/category/fair-trade-federation",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
